module.exports = __webpack_public_path__ + "static/logo-b2924838f69276cb66cccdc6dc24b64b.svg";